import { useMemo } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { CheckboxField } from '@namespace/forms';
import { useGetActualPrefixForPath, useI18n } from '@namespace/i18n';

import styles from '../../index.module.css';

const ConfirmAge = (props) => {
  const { t, language } = useI18n();
  const getActualPrefixForPath = useGetActualPrefixForPath();
  const { termsOfUse } = useGeneralRoutes();

  const linkToTermAndConditions = useMemo(() => {
    return `${getActualPrefixForPath(`/${language}`)}${termsOfUse}/`;
  }, [language]);

  return (
    <CheckboxField
      LabelComponent={
        <>
          {t('register.steps.secretQuestion.confirmAge1')}
          <a
            className={styles.confirmLink}
            href={linkToTermAndConditions}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t('register.steps.secretQuestion.generalTermsLink')}
          </a>
          {t('register.steps.secretQuestion.confirmAge2')}
        </>
      }
      {...props}
    />
  );
};

export default ConfirmAge;
